import { Injectable, signal } from '@angular/core';
import { GetMultiPartnerModelRequest, PartnerModel, PartnerModelApiService } from '@vendasta/partner';
import { map, take } from 'rxjs/operators';

const RECENT_PARTNERS_KEY = 'vcc:recentPartners';
const MAX_RECENT_PARTNERS = 5;

@Injectable()
export class PartnerSwitcherService {
  recentPartners = signal<PartnerModel[]>([]);

  constructor(private partnerModelService: PartnerModelApiService) {
    this.loadRecentPartners();
  }

  saveRecentPartner(partnerId: string): void {
    if (!partnerId) {
      return;
    }

    let recentPartnerIds = this.getRecentPartnerIds();

    recentPartnerIds = recentPartnerIds.filter((recentPartnerId) => recentPartnerId !== partnerId);
    recentPartnerIds.unshift(partnerId);

    if (recentPartnerIds.length > MAX_RECENT_PARTNERS) {
      recentPartnerIds = recentPartnerIds.slice(0, MAX_RECENT_PARTNERS);
    }
    localStorage.setItem(RECENT_PARTNERS_KEY, JSON.stringify(recentPartnerIds));
  }

  private getRecentPartnerIds(): string[] {
    const recentPartnersSerialized = localStorage.getItem(RECENT_PARTNERS_KEY);
    let recentPartners = [];
    if (recentPartnersSerialized) {
      try {
        recentPartners = JSON.parse(recentPartnersSerialized);
      } catch {
        console.error('recent partners data from localStorage could not be loaded');
      }
    }
    return recentPartners;
  }

  private loadRecentPartners(): void {
    const recentPartners = this.getRecentPartnerIds();
    if (!recentPartners.length) return;

    this.partnerModelService
      .getMultiPartnerModel(new GetMultiPartnerModelRequest({ partnerIds: recentPartners }))
      .pipe(
        map((resp) => {
          if (!resp?.partners) return [];
          return resp.partners;
        }),
        take(1),
      )
      .subscribe((partners) => {
        this.recentPartners.set(partners);
      });
  }
}
